<template>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <h4 id="modifyPricerowsDescription"></h4>
          <template v-if="hasRateplans && selectedPricerows && selectedPricerows.length">
            <div class="form-group">
              <label for="rateplanFilterSelector">{{ _('Apply to') }}</label><br />
              <select class="form-control" id="rateplanFilterSelector" v-model="rateplanFilter">
                <option value="">{{ _('All selected price rows') }}</option>
                <option value="none">{{ _('Price rows for all rates') }}</option>
                <option v-for="rateplan in rateplans" :value="String(rateplan.id)">{{ _('Price rows for the rate %s').replace('%s', rateplan.title) }}</option>
              </select>
            </div>
            <ul class="list-group affected-pricerows">
              <li class="list-group-item" v-for="pricerow in affectedPricerows">{{ pricerow.name }} <span class="text-muted pull-right">{{ rateplanTitle(pricerow) }}</span></li>
              <li class="list-group-item text-muted" v-if="!affectedPricerows.length">{{ _('No selected price rows match the filter.') }}</li>
            </ul>
          </template>
          <div class="form-group">
            <label for="operationSelector">{{ _('Select operation') }}</label><br />
            <select class="form-control" id="operationSelector" v-model="operation">
              <option :value="null">{{ _('Select...') }}</option>
              <template v-if="this.selectedPricerows && this.selectedPricerows.length">
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="alldates">{{ _('Change all dates') }}</option>
                <option value="startdates">{{ _('Change start dates') }}</option>
                <option value="enddates">{{ _('Change end dates') }}</option>
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="weekdays">{{ _('Change weekdays') }}</option>
                <option value="startweekdays">{{ _('Change start weekdays') }}</option>
                <option value="endweekdays">{{ _('Change end weekdays') }}</option>
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="allprices">{{ _('Change all base prices') }}</option>
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="unittypes">{{ _('Change unit types') }}</option>
                <option value="units">{{ _('Change units') }}</option>
                <template v-if="enableParticipantPricing">
                  <option disabled="disabled">────────────────────────────────────────</option>
                  <option value="includes">{{ _('Change participants included') }}</option>
                  <option value="minparticipants">{{ _('Change mininum participants') }}</option>
                  <option value="maxparticipants">{{ _('Change maximum participants') }}</option>
                </template>
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="minresources">{{ _('Change mininum resources') }}</option>
                <option value="maxresources">{{ _('Change maximum resources') }}</option>
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="mindurations">{{ _('Change mininum durations') }}</option>
                <option value="maxdurations">{{ _('Change maximum durations') }}</option>
                <template v-if="hasRateplans">
                  <option disabled="disabled">────────────────────────────────────────</option>
                  <option value="rateplan">{{ _('Change rate') }}</option>
                </template>
                <option disabled="disabled">────────────────────────────────────────</option>
                <option value="duplicate">{{ _('Duplicate selected price rows') }}</option>
                <option value="delete">{{ _('Delete selected price rows') }}</option>
              </template>
              <template v-else>
                <option value="copyfromproduct">{{ _('Copy price rows from another product') }}</option>
              </template>
            </select>
          </div>
          <div id="unittypesOperation" class="operation-fields" v-if="operation === 'unittypes'">
            <div class="form-group">
              <label for="unittypeValueSelector">{{ _('Change unit type') }}</label><br />
              <select class="form-control" id="unittypeValueSelector" v-model="params.unittype">
                <option value="1">{{ _('minute(s)') }}</option>
                <option value="2">{{ _('hour(s)') }}</option>
                <option value="3">{{ _('day(s)') }}</option>
              </select>
            </div>
          </div>
          <div id="unitsOperation" class="operation-fields" v-if="operation === 'units'">
            <div class="form-group">
              <label for="unitOperationValue">{{ _('Unit') }}</label><br />
              <input type="number" data-android-inputmode="decimal" class="form-control" id="unitOperationValue" v-model="params.unit" />
            </div>
          </div>
          <div id="includesOperation" class="operation-fields" v-if="operation === 'includes'">
            <div class="form-group">
              <label for="includeOperationValue">{{ _('Base price includes') }}</label><br />
              <input type="number" data-android-inputmode="decimal" class="form-control" id="includeOperationValue" v-model="params.includes" />
            </div>
          </div>
          <div id="participantsOperation" class="operation-fields" v-if="operation === 'participants' || operation === 'minparticipants' || operation === 'maxparticipants'">
            <div class="form-group">
              <label for="participantOperationValue">{{ _('Participants') }}</label><br />
              <input type="number" data-android-inputmode="decimal" class="form-control" id="participantOperationValue" v-model="params.participants" />
            </div>
          </div>
          <div id="resourcesOperation" class="operation-fields" v-if="operation === 'minresources' || operation === 'maxresources'">
            <div class="form-group">
              <label for="resourceOperationValue">{{ _('Resources') }}</label><br />
              <input type="number" data-android-inputmode="decimal" class="form-control" id="resourceOperationValue" v-model="params.resources" />
            </div>
          </div>
          <div id="rateplanOperation" class="operation-fields" v-if="operation === 'rateplan'">
            <div class="form-group">
              <label for="rateplanOperationValue">{{ _('Rate plan') }}</label><br />
              <select class="form-control" id="rateplanOperationValue" v-model="params.rateplan_id">
                <option value="">{{ _('All rates') }}</option>
                <option v-for="rateplan in rateplans" :value="String(rateplan.id)">{{ rateplan.title }}</option>
              </select>
            </div>
          </div>
          <div id="durationsOperation" class="operation-fields" v-if="operation === 'mindurations' || operation === 'maxdurations'">
            <div class="form-inline">
              <div class="form-group">
                <label for="durationOperationValue">{{ _('Duration') }}</label><br />
                <input type="number" data-android-inputmode="decimal" class="form-control" id="durationOperationValue" v-model="params.duration" />
              </div>
              <div class="form-group">
                <label for="durationOperationTypeSelector">&nbsp;</label><br />
                <select class="form-control" id="durationOperationTypeSelector" v-model="params.internalduration">
                  <option value="0">{{ _('within the reservation') }}</option>
                  <option value="1">{{ _('within the price row') }}</option>
                </select>
              </div>
            </div>
          </div>
          <div id="allpricesOperation" class="operation-fields" v-if="operation === 'allprices'">
            <div class="form-group">
              <label for="priceOperationSelector">{{ _('Modify prices') }}</label><br />
              <select class="form-control" id="priceOperationSelector" v-model="params.operator">
                <option value="set">{{ _('Set exact price') }}</option>
                <option value="add">{{ _('Add to current price') }}</option>
                <option value="sub">{{ _('Subtract from current price') }}</option>
                <option value="addperc">{{ _('Add percentage') }}</option>
                <option value="subperc">{{ _('Subtract percentage') }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="priceOperationValue">{{ _('New value') }}</label><br />
              <input type="text" class="form-control" id="priceOperationValue" v-model="params.value" />
            </div>
          </div>
          <div id="alldatesOperation" class="operation-fields" v-if="operation === 'alldates' || operation === 'startdates' || operation === 'enddates'">
            <div class="form-group">
              <label for="dateOperationSelector">{{ _('Modify dates') }}</label><br />
              <select class="form-control" id="dateOperationSelector" v-model="params.operator">
                <option value="set">{{ _('Set parts separately') }}</option>
                <option value="add">{{ _('Add to current date') }}</option>
                <option value="sub">{{ _('Subtract from current date') }}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="input-group" id="dayInputs">
                <input type="text" class="form-control" id="dateOperationDays" v-model="params.day" />
                <div class="input-group-addon">{{ _('day') }}</div>
                <input type="text" class="form-control" id="dateOperationMonths" v-model="params.month" />
                <div class="input-group-addon">{{ _('month') }}</div>
                <input type="text" class="form-control" id="dateOperationYears" v-model="params.year" />
                <div class="input-group-addon">{{ _('year') }}</div>
              </div>
            </div>
          </div>
          <div id="daysOperation" class="operation-fields" v-if="operation === 'weekdays' || operation === 'startweekdays' || operation === 'endweekdays'">
            <div class="form-group">
              <label for="dayOperationSelector">{{ _('Modify days') }}</label><br />
              <select class="form-control" id="dayOperationSelector" v-model="params.operator">
                <option value="set">{{ _('Set days') }}</option>
                <option value="add">{{ _('Add to current days') }}</option>
                <option value="sub">{{ _('Subtract from current days') }}</option>
              </select>
            </div>
            <div class="form-group">
              <div class="input-group">
                <div class="btn-group flex-row daybuttons" id="dayOperationRangeButtons">
                  <label :class="'btn btn-sm ' + (weekdays.includes('1') ? 'btn-success' : 'btn-default')" data-value="1">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="1" /> {{ _('mo') }}
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('2') ? 'btn-success' : 'btn-default')" data-value="2">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="2" /> {{ _('tu') }}
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('3') ? 'btn-success' : 'btn-default')" data-value="3">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="3" /> {{ _('we') }}
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('4') ? 'btn-success' : 'btn-default')" data-value="4">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="4" /> {{ _('th') }}
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('5') ? 'btn-success' : 'btn-default')" data-value="5">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="5" /> {{ _('fr') }}
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('6') ? 'btn-success' : 'btn-default')" data-value="6">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="6" /> {{ _('sa') }}
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('7') ? 'btn-success' : 'btn-default')" data-value="7">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="7" /> {{ _('su') }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" v-on:click="done" :disabled="!operation"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      operation: null,
      rateplanFilter: '',
      params: {
        operator: 'set',
        internalduration: '0'
      }
    }
  },
  props: ['enableParticipantPricing','selectedPricerows', 'pricerows', 'rateplans'],
  computed: {
    hasRateplans () { // Activity pricing: the product has rate plans that price rows can belong to
      return !!(this.rateplans && this.rateplans.length)
    },
    affectedPricerows () {
      if (!this.pricerows) {
        return []
      }
      return this.pricerows.filter(p => this.selectedPricerows.includes(p.id) && this.matchesRateplanFilter(p))
    },
    weekdays: {
      get() {
        return this.params && this.params.weekdays && this.params.weekdays.split ? this.params.weekdays.split(',') : []
      },
      set(newValue) {
        this.params.weekdays = newValue.sort().join(',')
      }
    },
  },
  watch: {
    operation (newValue) {
      if (newValue === 'rateplan' && this.params.rateplan_id === undefined) {
        this.params.rateplan_id = ''
      }
    },
    weekdays (newValue, oldValue) {
      if (oldValue.length === 7 && newValue.length === 6) {
        const diff = oldValue.filter(x => !newValue.includes(x))
        nextTick(() => { this.weekdays = diff })
      }
      if (oldValue.length === 1 && newValue.length === 0) {
        nextTick(() => { this.weekdays = [1, 2, 3, 4, 5, 6, 7] })
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    matchesRateplanFilter (pricerow) {
      if (!this.rateplanFilter) {
        return true
      }
      if (this.rateplanFilter === 'none') {
        return !pricerow.rateplan_id
      }
      return String(pricerow.rateplan_id) === this.rateplanFilter
    },
    rateplanTitle (pricerow) {
      if (!pricerow.rateplan_id) {
        return this._('All rates')
      }
      const rateplan = this.rateplans.find(r => String(r.id) === String(pricerow.rateplan_id))
      return rateplan ? rateplan.title : '#' + pricerow.rateplan_id
    },
    done () {
      if (this.params.value) {
        if (String(this.params.value).indexOf(',')) {
          this.params.value = String(this.params.value).replace(',','.')
        }
      }
      if (this.hasRateplans) {
        this.params.rateplanFilter = this.rateplanFilter
      }
      this.$emit('done', { operation: this.operation, params: this.params })
    }
  }
}
</script>

<style scoped>
.daybuttons input {
  display: none;
}
.affected-pricerows {
  max-height: 200px;
  overflow-y: auto;
}
</style>